import { createContext as i, useContext as l, useEffect as t } from "react";
const a = i({
  revalidateForms: () => {
  },
  formCollection: [],
  setFormCollection: () => {
  }
}), d = (e) => {
  const {
    revalidateForms: o,
    setFormCollection: n
  } = l(a);
  t(() => {
    o(e);
  }, [
    e.id,
    e.isBlocked
  ]), t(() => () => {
    n((r) => r.filter((s) => s.id !== e.id));
  }, []);
};
export {
  a as UnsavedChangesContext,
  d as useUnsavedChanges
};
